export default __webpack_public_path__ + "static/media/mailWhite.3c0f520d.svg";